import SettingsState from './settings.state';
import SettingsTypes from './settings.types';
import UserTypes from '../user/user.types';
import AnyAction from 'store/anyActions';

export default function (
    state: Partial<SettingsState> = {},
    action: AnyAction
): Partial<SettingsState> {
    switch (action.type) {
        case SettingsTypes.SET_RINGING_DEVICE:
            return {
                ...state,
                ringingDevice: action.payload,
            };
        case SettingsTypes.GET_GLOBAL_LINE:
            return {
                ...state,
                globalLine: action.payload,
                globalLineError: false,
                globalLineLoading: false,
            };

        case SettingsTypes.GET_GLOBAL_LINE_ERROR:
            return {
                ...state,
                globalLineError: true,
                globalLineLoading: false,
            };

        case SettingsTypes.UPDATE_GLOBAL_LINE:
            return {
                ...state,
                globalLine: action.payload,
                globalLineLoading: false,
            };
        case SettingsTypes.GET_GLOBAL_LINE_LOADING:
            return {
                ...state,
                globalLineLoading: action.payload.loading,
            };
        case SettingsTypes.GET_LINES:
            return {
                ...state,
                lines: action.payload,
                linesLoading: false,
                filteredLines: {
                    keyword: '',
                    status: null,
                }
            };
        case SettingsTypes.GET_LINES_LOADING:
            return {
                ...state,
                linesLoading: action.payload.loading,
            };
        case SettingsTypes.UPDATE_LINES:
            return {
                ...state,
                lines: state!.lines!.map(line =>
                    line.ID === action.payload.ID ? { ...line, ...action.payload } : line
                ),
            };
        case SettingsTypes.SET_FILTERED_LINES:
            return {
                ...state,
                filteredLines: action.payload
            };
        case SettingsTypes.UPDATE_LINES_LOADING:
            return {
                ...state,
                updateLinesLoading: action.payload.loading,
            };
        case SettingsTypes.GET_REPORTS:
            return {
                ...state,
                reports: action.payload,
            };
        case SettingsTypes.GET_REPORTS_LOADING:
            return {
                ...state,
                reportsLoading: action.payload.loading,
            };
        case SettingsTypes.GENERATE_REPORTS_LOADING:
            return {
                ...state,
                generateReportsLoading: action.payload.loading,
            };
        case SettingsTypes.GET_ROUTING_PROFILES:
            return {
                ...state,
                routingProfiles: action.payload,
            };
        case SettingsTypes.GET_SECURITY_GROUPS:
            return {
                ...state,
                securityGroups: action.payload,
            };
        case SettingsTypes.GET_USER_HIERARCHY:
            return {
                ...state,
                userHierarchy: action.payload,
            };
        case SettingsTypes.GET_HIERARCHY_GROUPS:
            return {
                ...state,
                hierarchyGroups: action.payload,
            };
        case SettingsTypes.GET_USERS:
            return {
                ...state,
                users: action.payload,
                usersLoading: false,
                usersError: false,
            };
        case SettingsTypes.GET_USERS_LOADING:
            return {
                ...state,
                usersLoading: action.payload.loading,
            };
        case SettingsTypes.GET_USERS_ERROR:
            return {
                ...state,
                usersError: action.payload.error,
                usersLoading: false,
            };
        case SettingsTypes.DELETE_USER:
            return {
                ...state,
                users: state!.users!.filter(agent => agent.ID !== action.payload.ID),
                userDeleting: null,
                userDeletingInProgress: false,
            };
        case SettingsTypes.DELETE_USER_LOADING:
            return {
                ...state,
                userDeletingInProgress: action.payload.loading,
            };
        case SettingsTypes.DELETE_USER_ERROR:
            return {
                ...state,
                userDeletingError: action.payload.error,
                userDeletingInProgress: false,
                userDeleting: null,
            };
        case SettingsTypes.DELETING_USER:
            return {
                ...state,
                userDeleting: action.payload.agent,
            };
        case SettingsTypes.DISABLE_USER:
            return {
                ...state,
                users: state!.users!.map(agent => agent.ID !== action.payload.ID ?
                    agent :
                    {
                        ...agent,
                        disabled: true
                    }
                ),
                userDisabling: null,
                userDisablingInProgress: false,
            };
        case SettingsTypes.DISABLE_USER_LOADING:
            return {
                ...state,
                userDisablingInProgress: action.payload.loading,
            };
        case SettingsTypes.DISABLE_USER_ERROR:
            return {
                ...state,
                userDisablingError: action.payload.error,
                userDisablingInProgress: false,
                userDisabling: null,
            };
        case SettingsTypes.DISABLING_USER:
            return {
                ...state,
                userDisabling: action.payload.agent,
            };
        case SettingsTypes.ENABLE_USER:
            return {
                ...state,
                users: state!.users!.map(agent => agent.ID !== action.payload.ID ?
                    agent :
                    {
                        ...agent,
                        disabled: false
                    }
                ),
                userEnabling: null,
                userEnablingInProgress: false,
            };
        case SettingsTypes.ENABLE_USER_LOADING:
            return {
                ...state,
                userEnablingInProgress: action.payload.loading,
            };
        case SettingsTypes.ENABLE_USER_ERROR:
            return {
                ...state,
                userEnablingError: action.payload.error,
                userEnablingInProgress: false,
                userEnabling: null,
            };
        case SettingsTypes.ENABLING_USER:
            return {
                ...state,
                userEnabling: action.payload.agent,
            };
        case SettingsTypes.ADDING_USER_LOADING:
            return {
                ...state,
                userAddingInProgress: action.payload.adding,
            };
        case SettingsTypes.ADD_USER_ERROR:
            return {
                ...state,
                userAddingError: action.payload.error,
                userAddingInProgress: false,
            };
        case SettingsTypes.ADDING_USER:
            return {
                ...state,
                userAdding: action.payload.adding,
            };
        case SettingsTypes.ADD_USER:
            return {
                ...state,
                users: [...state!.users!, action.payload],
                userAddingError: '',
                userAddingInProgress: false,
                userAdding: false,
            };
        case SettingsTypes.EDIT_USER_REFRESH:
            return {
                ...state,
                userRefreshing: action.payload.refresh,
            };
        case SettingsTypes.EDITING_USER_LOADING:
            return {
                ...state,
                userEditingInProgress: action.payload.editing,
            };
        case SettingsTypes.EDIT_USER_ERROR:
            return {
                ...state,
                userEditingInProgress: false,
                userEditing: null,
                userEditingError: action.payload.error,
            };
        case SettingsTypes.EDITING_USER:
            return {
                ...state,
                userEditing: action.payload,
                userRefreshing: false,
                userEditingError: undefined,
            };
        case SettingsTypes.EDIT_USER:
            return {
                ...state,
                userEditing: null,
                userEditingInProgress: false,
                users: state?.users?.map(user =>
                    user.ID === action.payload.ID ? action.payload : user
                ),
            };
        case SettingsTypes.GET_QUEUES:
            return {
                ...state,
                queues: action.payload,
            };
        case SettingsTypes.GET_ENABLED_QUEUES:
            return {
                ...state,
                enabledQueues: action.payload,
            };
        case SettingsTypes.GET_EMAIL_TEMPLATES:
            return {
                ...state,
                emailTemplates: action.payload,
            };
        case SettingsTypes.GET_ALLOWED_ATTACHMENT_TYPES:
            return {
                ...state,
                allowedAttachmentTypes: action.payload,
            };
        case SettingsTypes.GET_CONTACT_FLOWS:
            return {
                ...state,
                contactFlows: action.payload,
            };
        case SettingsTypes.GET_PERMISSIONS:
            return {
                ...state,
                permissions: action.payload,
            };
        case SettingsTypes.GET_PERMISSIONS_ERROR:
            return {
                ...state,
                permissionsError: action.payload,
            }
        case SettingsTypes.GET_FEATURE_LIST:
            return {
                ...state,
                featureList: action.payload,
            };
        case SettingsTypes.GET_COGNITO_CONFIG:
            return {
                ...state,
                cognitoConfig: action.payload.config
            };
        case SettingsTypes.GET_SETTINGS:
            return {
                ...state,
                settingsLoading: false,
                settings: action.payload
            };
        case SettingsTypes.GET_SETTINGS_LOADING:
            return {
                ...state,
                settingsLoading: action.payload
            }
        case SettingsTypes.EDIT_SETTINGS_LOADING:
            return {
                ...state,
                editSettingsLoading: action.payload
            }
        case SettingsTypes.EDIT_SETTINGS:
            return {
                ...state,
                editSettingsLoading: false,
                //@ts-ignore
                settings: action.payload
            }
        case SettingsTypes.ENABLE_WEBHID:
            return {
                ...state,
                userHasEnabledWebHID: true
            }
        case SettingsTypes.DISABLE_WEBHID:
            return {
                ...state,
                userHasEnabledWebHID: false
            }
        //@ts-ignore
        case UserTypes.LOGOUT:
            return {
                ringingDevice: state?.ringingDevice,
                userHasEnabledWebHID: state?.userHasEnabledWebHID
            };

        case SettingsTypes.GET_AUDIT_LOGS_LOADING:
            return {
                ...state,
                auditLogs: {
                    logs: [],
                    auditLogsLoading: action.payload.loading,
                    auditLogsError: false,
                    orderBy: '',
                    sortDirection: '',
                    filters: {},
                    totalTableRowCount: 0,
                    currentTablePage: 1
                }
            };

        case SettingsTypes.GET_AUDIT_LOGS:
            return {
                ...state,
                auditLogs: {
                    auditLogsLoading: false,
                    logs: action.payload.data,
                    auditLogsError: false,
                    orderBy: action.payload.orderBy,
                    sortDirection: action.payload.sortDirection,
                    filters: action.payload.filters,
                    totalTableRowCount: action.payload.totalCount,
                    currentTablePage: action.payload.page
                }
            };

        case SettingsTypes.GET_AUDIT_LOGS_ERROR:
            return {
                ...state,
                auditLogs: {
                    logs: [],
                    auditLogsLoading: false,
                    auditLogsError: action.payload.error,
                    orderBy: '',
                    sortDirection: '',
                    filters: {},
                    totalTableRowCount: 0,
                    currentTablePage: 1
                }
            };

        case SettingsTypes.GET_SETTING_NAMES_FOR_AUDIT_LOGS_LOADING:
            return {
                ...state,
                settingNamesForAuditLogs: {
                    settingNamesLoading: action.payload.loading,
                    settingNames: [],
                    settingNamesError: false,
                },
            };

        case SettingsTypes.GET_SETTING_NAMES_FOR_AUDIT_LOGS:
            return {
                ...state,
                settingNamesForAuditLogs: {
                    settingNamesLoading: false,
                    settingNames: action.payload,
                    settingNamesError: false,
                },
            };

        case SettingsTypes.GET_SETTING_NAMES_FOR_AUDIT_LOGS_ERROR:
            return {
                ...state,
                settingNamesForAuditLogs: {
                    settingNamesLoading: false,
                    settingNames: [],
                    settingNamesError: action.payload.error,
                },
            };

        case SettingsTypes.GET_USERS_LIST_FOR_AUDIT_LOGS_LOADING:
            return {
                ...state,
                usersListForAuditLogs: {
                    usersListLoading: action.payload.loading,
                    usersList: [],
                    usersListError: false,
                },
            };

        case SettingsTypes.GET_USERS_LIST_FOR_AUDIT_LOGS:
            return {
                ...state,
                usersListForAuditLogs: {
                    usersListLoading: false,
                    usersList: action.payload,
                    usersListError: false,
                },
            };

        case SettingsTypes.GET_USERS_LIST_FOR_AUDIT_LOGS_ERROR:
            return {
                ...state,
                usersListForAuditLogs: {
                    usersListLoading: false,
                    usersList: [],
                    usersListError: action.payload.error,
                },
            };

        case SettingsTypes.GET_CALLBACK_QUEUES_LOADING:
            return {
                ...state,
                callbackQueues: {
                    queues: [],
                    getCallbackQueuesLoading: action.payload.loading,
                    getCallbackQueuesError: false,
                    updateCallbackQueueLoading: false,
                    updateCallbackQueueError: false,
                }
            };

        case SettingsTypes.GET_CALLBACK_QUEUES:
            return {
                ...state,
                callbackQueues: {
                    getCallbackQueuesLoading: false,
                    queues: action.payload,
                    getCallbackQueuesError: false,
                    updateCallbackQueueLoading: false,
                    updateCallbackQueueError: false,
                }
            };

        case SettingsTypes.GET_CALLBACK_QUEUES_ERROR:
            return {
                ...state,
                callbackQueues: {
                    queues: [],
                    getCallbackQueuesLoading: false,
                    getCallbackQueuesError: action.payload.error,
                    updateCallbackQueueLoading: false,
                    updateCallbackQueueError: false,
                }
            };
        case SettingsTypes.UPDATE_CALLBACK_QUEUE_LOADING:
            return {
                ...state,
                callbackQueues: {
                    getCallbackQueuesLoading: false,
                    getCallbackQueuesError: false,
                    queues: state.callbackQueues?.queues!,
                    updateCallbackQueueLoading: action.payload.loading,
                    updateCallbackQueueError: false,
                }
            };
        case SettingsTypes.UPDATE_CALLBACK_QUEUE: {
            const restQueues = state.callbackQueues?.queues.
                filter(queue => queue.queueId !== action.payload.queueId);
            return {
                ...state,
                callbackQueues: {
                    getCallbackQueuesLoading: false,
                    getCallbackQueuesError: false,
                    queues: [...restQueues!, action.payload],
                    updateCallbackQueueLoading: false,
                    updateCallbackQueueError: false,
                }
            };
        }
        case SettingsTypes.UPDATE_CALLBACK_QUEUE_ERROR:
            return {
                ...state,
                callbackQueues: {
                    getCallbackQueuesLoading: false,
                    getCallbackQueuesError: false,
                    queues: state.callbackQueues?.queues!,
                    updateCallbackQueueLoading: false,
                    updateCallbackQueueError: action.payload.error,
                }
            };
        default:
            return state;
    }
}
